var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53828 11.9478C4.23898 11.9478 4.03016 11.8156 3.81439 11.5441L0.201856 6.9432C0.0696056 6.77614 0 6.59517 0 6.43508C0 6.05225 0.278422 5.78078 0.668213 5.78078C0.893561 5.78078 1.04963 5.85539 1.2017 6.03725L4.51044 10.3678L10.761 0.407234C10.9281 0.142733 11.0882 0.0522461 11.3596 0.0522461C11.7425 0.0522461 12 0.302826 12 0.685657C12 0.84575 11.9443 0.998882 11.819 1.20074L5.2413 11.558C5.07425 11.8156 4.83759 11.9478 4.53828 11.9478Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckmarkWhite.5eae70269128b57107c3cfe711a407b4.svg";